@if (schedule) {
  <div class="pebl-dialog">
    <div class="pebl-dialog__header">
      <div class="pebl-dialog__header-main">
        <p class="pebl-dialog__eyebrow">Scheduled Link</p>
        <h1 class="pebl-dialog__amount">
          {{ schedule.amount / 100 | currency: currencyAlphaCode }}
        </h1>
      </div>
      <button
        mat-icon-button
        class="pebl-dialog__close"
        [mat-dialog-close]
        data-test="tx-pebl-schedule-details-close-icon-button"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="pebl-dialog__badge-row">
      <span class="pebl-dialog__badge {{ statusBadgeClass() }}">
        <mat-icon>{{ statusIcon() }}</mat-icon>
        {{ schedule.status }}
      </span>
      <span class="pebl-dialog__badge mon-bg-primary mon-text-primary">
        <mat-icon class="outline">{{ deliveryIcon() }}</mat-icon>
        {{ scheduleSummary() }}
      </span>
    </div>

    <mat-dialog-content class="pebl-dialog__body">
      <div class="pebl-dialog__section">
        <h2 class="pebl-dialog__section-title">Overview</h2>
        <div class="pebl-dialog__grid">
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Customer name</span>
            <p class="pebl-dialog__value">{{ schedule.name || '-' }}</p>
          </div>
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Created</span>
            <p class="pebl-dialog__value">
              {{ (schedule.createdAt | date: 'dd/MM/yy HH:mm') || '-' }}
            </p>
          </div>
          @if (schedule.status === 'Active' || schedule.status === 'Sending') {
            <div class="pebl-dialog__item">
              <span class="pebl-dialog__label">Next send</span>
              <p class="pebl-dialog__value">
                {{ (schedule.nextSendAt | date: 'dd/MM/yy HH:mm') || '-' }}
              </p>
            </div>
          }
          @if (schedule.type === 'Recurring') {
            <div class="pebl-dialog__item">
              <span class="pebl-dialog__label">Starts</span>
              <p class="pebl-dialog__value">
                {{ (schedule.startDate | date: 'dd/MM/yy HH:mm') || '-' }}
              </p>
            </div>
            @if (schedule.endDate) {
              <div class="pebl-dialog__item">
                <span class="pebl-dialog__label">Ends</span>
                <p class="pebl-dialog__value">
                  {{ schedule.endDate | date: 'dd/MM/yy' }}
                </p>
              </div>
            }
          }
          @if (schedule.lastSentAt) {
            <div class="pebl-dialog__item">
              <span class="pebl-dialog__label">Last sent</span>
              <p class="pebl-dialog__value">
                {{ schedule.lastSentAt | date: 'dd/MM/yy HH:mm' }}
              </p>
            </div>
          }
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Send method</span>
            <p class="pebl-dialog__value">
              <mat-icon class="outline">{{ deliveryIcon() }}</mat-icon>
              {{ recipient() }}
            </p>
          </div>
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Created by</span>
            <p class="pebl-dialog__value">
              {{ schedule.operatorName || schedule.operatorEmail || '-' }}
            </p>
            @if (schedule.operatorName && schedule.operatorEmail) {
              <p class="pebl-dialog__value">{{ schedule.operatorEmail }}</p>
            }
          </div>
          <div class="pebl-dialog__item pebl-dialog__item--full">
            <span class="pebl-dialog__label">Description</span>
            <p class="pebl-dialog__value">{{ schedule.paymentDetail }}</p>
          </div>
          @if (schedule.status === 'Cancelled') {
            <div class="pebl-dialog__item pebl-dialog__item--full">
              <span class="pebl-dialog__label">Cancellation reason</span>
              <p class="pebl-dialog__value">
                {{ schedule.cancellationReason || '-' }}
              </p>
            </div>
          }
          @if (schedule.status === 'Failed' && schedule.lastError) {
            <div class="pebl-dialog__item pebl-dialog__item--full">
              <span class="pebl-dialog__label">Last error</span>
              <p class="pebl-dialog__value">{{ schedule.lastError }}</p>
            </div>
          }
        </div>
      </div>

      @if (occurrencesFetched && (occurrences.length > 0 || occurrencesError)) {
        <div class="pebl-dialog__section">
          <h2 class="pebl-dialog__section-title">Send History</h2>
          @if (occurrencesError && occurrences.length === 0) {
            <p class="pebl-dialog__label">
              {{ occurrencesErrorText }}
              <button
                mat-button
                class="mon-text-primary"
                (click)="LoadOccurrences()"
                data-test="tx-pebl-schedule-details-retry-occurrences-button"
              >
                Retry
              </button>
            </p>
          }
          <div class="pebl-dialog__audit-list">
            @for (occurrence of occurrences; track occurrence.paymentReference) {
              <div
                class="pebl-dialog__audit-item pebl-dialog__audit-item--clickable"
                (click)="ToggleOccurrence(occurrence)"
                (keydown.enter)="ToggleOccurrence(occurrence)"
                tabindex="0"
                role="button"
                data-test="tx-pebl-schedule-details-occurrence-row"
              >
                <mat-icon class="outline">send</mat-icon>
                <div class="pebl-dialog__audit-body">
                  <p
                    class="pebl-dialog__value {{
                      occurrenceStatusClass(occurrence)
                    }}"
                  >
                    Send #{{ occurrence.occurrenceNumber }} &mdash;
                    {{ occurrenceStatusText(occurrence) }}
                  </p>
                  <span class="pebl-dialog__label">
                    {{ occurrence.sentAt | date: 'dd/MM/yy HH:mm' }}
                  </span>
                </div>
                <mat-icon class="outline">
                  {{ isExpanded(occurrence) ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </div>
              @if (isExpanded(occurrence)) {
                <div class="pebl-dialog__audit-nested">
                  @if (auditLoading[occurrence.paymentReference]) {
                    <span class="pebl-dialog__label">Loading attempts...</span>
                  } @else if (auditErrors[occurrence.paymentReference]) {
                    <span class="pebl-dialog__label">
                      {{ auditErrorTexts[occurrence.paymentReference] }}
                      <button
                        mat-button
                        class="mon-text-primary"
                        (click)="LoadAudit(occurrence)"
                        data-test="tx-pebl-schedule-details-retry-audit-button"
                      >
                        Retry
                      </button>
                    </span>
                  } @else if (auditFor(occurrence).length === 0) {
                    <span class="pebl-dialog__label">
                      No payment attempts yet.
                    </span>
                  } @else {
                    @for (event of auditFor(occurrence); track $index) {
                      <div class="pebl-dialog__audit-item">
                        <mat-icon class="outline {{ auditEventClass(event) }}">
                          {{ auditEventIcon(event) }}
                        </mat-icon>
                        <div class="pebl-dialog__audit-body">
                          <p
                            class="pebl-dialog__value {{
                              auditEventClass(event)
                            }}"
                          >
                            {{ event.status || '-' }}
                          </p>
                          <span class="pebl-dialog__label">
                            {{ event.createdDate | date: 'dd/MM/yy HH:mm' }}
                            @if (event.message) {
                              {{ event.message }}
                            }
                          </span>
                        </div>
                        @if (hasAuditEventDetails(event)) {
                          <button
                            mat-stroked-button
                            class="pebl-dialog__audit-action bg-white-always mon-border-primary border mon-text-primary"
                            (click)="viewAuditEventTransaction(event)"
                            data-test="tx-pebl-schedule-details-audit-view-transaction-button"
                          >
                            View Details
                          </button>
                        }
                      </div>
                    }
                  }
                </div>
              }
            }
          </div>
          @if (occurrencesLoading) {
            <span class="pebl-dialog__label">Loading send history...</span>
          } @else if (hasMoreOccurrences) {
            <button
              mat-button
              class="mon-text-primary"
              (click)="LoadOccurrences()"
              data-test="tx-pebl-schedule-details-load-more-occurrences-button"
            >
              Load more
            </button>
          }
        </div>
      }
    </mat-dialog-content>

    <div class="pebl-dialog__actions">
      @if (schedule.status === 'Active') {
        <button
          mat-stroked-button
          class="mon-bg-danger mon-border-danger border mon-text-danger"
          [disabled]="actionButtonLoading || !GrantChecker()"
          (click)="CancelSchedule()"
          data-test="tx-pebl-schedule-details-cancel-schedule-button"
        >
          Cancel Schedule
        </button>
      }
      <div class="pebl-dialog__actions-spacer"></div>
      <button
        mat-flat-button
        class="bg-white-always mon-border-primary border mon-text-primary"
        [mat-dialog-close]
        cdkFocusInitial
        data-test="tx-pebl-schedule-details-close-button"
      >
        Close
      </button>
    </div>
  </div>
}

<odin-loading-spinner
  [active]="actionButtonLoading"
  [overlay]="true"
></odin-loading-spinner>
